import React from 'react';
import { motion } from 'framer-motion';
import { RotateCcw, Clock, CreditCard, AlertCircle } from 'lucide-react';

const ReturnRefund: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-50 to-premium-50">
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-r from-burgundy-100 via-cream-100 to-premium-100">
        <div className="container mx-auto px-4 safe-area-inset">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6">
              Return & Refund Policy
            </h1>
            <div className="w-24 h-1 gold-gradient rounded-full mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 leading-relaxed">
              Understanding our return and refund policy for custom cake orders and special circumstances.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 safe-area-inset">
          <div className="max-w-4xl mx-auto space-y-8">
            {[
              {
                icon: AlertCircle,
                title: "Custom Cake Policy",
                content: "Due to the custom nature of our cakes, returns are not accepted once production has begun. Each cake is made specifically for your order and cannot be resold. Please ensure all details are correct before confirming your order."
              },
              {
                icon: Clock,
                title: "Cancellation Timeframe",
                content: "Full refunds are available for cancellations made 72+ hours before delivery. Cancellations within 48-72 hours receive 50% refund. No refunds for cancellations within 48 hours of delivery due to ingredient purchasing and preparation."
              },
              {
                icon: CreditCard,
                title: "Refund Process",
                content: "Approved refunds will be processed within 5-7 business days to your original payment method. Bank transfer refunds may take 3-5 business days. We will notify you once the refund has been initiated."
              },
              {
                icon: RotateCcw,
                title: "Quality Guarantee",
                content: "If you're not satisfied with the quality of your cake, please contact us within 2 hours of delivery. We may offer a replacement cake, partial refund, or store credit based on the circumstances and photographic evidence."
              }
            ].map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="premium-card bento-card"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-burgundy-400 to-burgundy-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <section.icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-serif font-semibold text-gray-900 mb-4">
                      {section.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReturnRefund;
